import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editOrganizationalUnit(
    request: Boundaries["editOrganizationalUnit"]["request"],
  ): void;
}

function useEditOrganizationalUnit(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isEditOrganizationalUnitRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isEditOrganizationalUnitRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isEditOrganizationalUnitRequestFailure,
    ),
    editOrganizationalUnit: core.editOrganizationalUnit,
  };
}

export { useEditOrganizationalUnit };
